import PropTypes from 'prop-types';
import React from 'react';
import { StatusPill, ToggleSwitch } from 'components/v3';

// Live / Draft status visuals shared by the list card and the builder
// header. Colours are the Tracks list's Live / Inactive pills.

export const STATUS_STYLE = {
  live: {
    label: 'Live',
    color: 'rgb(31, 157, 87)',
    background: 'rgba(52, 210, 123, 0.13)',
    border: 'rgba(52, 210, 123, 0.34)',
  },
  draft: {
    label: 'Draft',
    color: 'rgb(100, 116, 139)',
    background: 'rgba(100, 116, 139, 0.13)',
    border: 'rgba(100, 116, 139, 0.34)',
  },
};

export const statusStyle = (status) =>
  status === 'live' ? STATUS_STYLE.live : STATUS_STYLE.draft;

export const nextStatus = (status) => (status === 'live' ? 'draft' : 'live');

export const FormStatusPill = ({ status }) => {
  const s = statusStyle(status);
  return (
    <StatusPill
      label={s.label}
      color={s.color}
      background={s.background}
      border={s.border}
    />
  );
};

FormStatusPill.propTypes = {
  status: PropTypes.oneOf(['live', 'draft']).isRequired,
};

const VISUALLY_HIDDEN = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

// The Live ⇄ Draft switch (FormCard, FormShellHeader), the design's success
// green when Live (tone="success"). ToggleSwitch has no `disabled` prop, so
// a disabled <fieldset> switches it off natively — mouse and keyboard
// alike — without touching the shared component.
export const StatusSwitch = ({ status, onChange, disabled, label, size }) => (
  <fieldset
    disabled={disabled}
    style={{
      border: 0,
      padding: 0,
      margin: 0,
      minWidth: 0,
      display: 'inline-flex',
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <legend style={VISUALLY_HIDDEN}>Status</legend>
    <ToggleSwitch
      on={status === 'live'}
      tone="success"
      size={size}
      label={label}
      onClick={() => {
        if (!disabled) onChange(nextStatus(status));
      }}
    />
  </fieldset>
);

StatusSwitch.propTypes = {
  status: PropTypes.oneOf(['live', 'draft']).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

StatusSwitch.defaultProps = {
  disabled: false,
  label: 'Live',
  size: 'md',
};
